// components/EmptyState.tsx
export const EmptyState: React.FC = () => {
  return (
    <div className="text-center py-8 text-muted-foreground">
      <div className="text-lg mb-2">Нет договоров</div>
      <div className="text-sm">У этой организации пока нет заключенных договоров</div>
    </div>
  );
};
